module.exports = __webpack_public_path__ + "img/quote-2-white.74ab1f63.png";